export const ROUTE_RENEW_BUNDLE = '/renew-plan';
export const ROUTE_CHECKOUT = '/checkout';
export const ROUTE_DEFAULT = '/';
